import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from '../i18n/pl';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";
import {DiscountService} from "../../../discount/service/discount.service";
import {Discounts} from "../../../discount/model/discounts";
import {AlertService} from "../../../services";


@Component({
    selector: 'discounts-dialog',
    templateUrl: './discountsDialog.component.html',
    styleUrls: ['./discountsDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class DiscountsDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    discounts: Discounts;
    loading: boolean;
    usedDiscounts = false;

    constructor(
        public matDialogRef: MatDialogRef<DiscountsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        private discountService: DiscountService,
        private alertService: AlertService,
        public _matDialog: MatDialog,
    ) {
        if (_data.discounts) {
            this.usedDiscounts = true;
            this.discounts = new Discounts();
            this.discounts.items = _data.discounts;
            this.discounts.total = this.discounts.items.length;
        } else {
            this.loading = true;
            this.discounts = new Discounts();
            this.discounts.items = [];
            this.discountService.getActive().subscribe((res: Discounts) => {
                this.discounts = res;
                this.loading = false;
            }, error => {
                this.alertService.error(error);
                this.loading = false;
            })
        }
        this.translationLoader.loadTranslations(polish);
    }
}
